module.exports = __webpack_public_path__ + "img/logo-presse-actu_200x200.e405ce3c.jpg";